import { ClientContext } from "@context/Client/ClientContext";
import { Card, CardContent, Divider, Grid, useTheme } from "@mui/material";
import { toLocaleString } from "@utils/numbers";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

export interface MetricCardProps {
  time_period: string;
  kpi: number;
  budget: number;
  comparison: number;
  showBudget?: boolean;
}

export const MetricCard = ({
  time_period,
  kpi: inflow,
  budget,
  comparison,
  showBudget = false
}: MetricCardProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { currentClient } = useContext(ClientContext);

  return (
    <Card className="w-full mt-4">
      <CardContent className="w-full">
        <Grid container sx={{ marginTop: 2, width: "100%" }}>
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            sx={{
              backgroundColor: "#E9ECFF",
              borderRadius: "0.25rem",
              fontWeight: "bold",
              padding: 1,
              width: "100%",
              textAlign: "center"
            }}
          >
            {time_period}
          </Grid>
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            sx={{
              fontWeight: 600,
              textAlign: "center",
              paddingTop: 1
            }}
          >
            {currentClient.client.kpi_label}
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ marginTop: 2, padding: 1 }}>
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            sx={{
              fontWeight: 600,
              fontSize: 20,
              textAlign: "center"
            }}
          >
            {toLocaleString(inflow, 0)}
          </Grid>
          {/* <Grid
            size={{ xs: 4, sm: 4, md: 6, lg: 4 }}
            sx={{
              //backgroundColor: comparison < 0 ? "#fef3f2" : "#ecfdf3",
              color:
                comparison < 0
                  ? theme.palette.error.main
                  : theme.palette.success.main,
              // borderRadius: 6,
              fontWeight: 600,
              justifyContent: "center",

              display: "flex",
              marginTop: 0.75
            }}
          >
            {comparison < 0 && (
              <ArrowDownwardIcon color="error" className="mr-1" />
            )}
            {comparison >= 0 && (
              <ArrowUpwardIcon color="success" className="mr-1" />
            )}
            {toLocaleString(comparison, 0)}%
          </Grid> */}
          <Grid
            size={{ xs: 12, sm: 12, md: 12 }}
            sx={{
              justifyContent: "center",
              marginTop: 1,
              textAlign: "center",
              display: showBudget ? "block" : "none"
            }}
          >
            <Divider />
          </Grid>
          <Grid
            size={{ xs: 5, sm: 5, md: 5 }}
            sx={{
              justifyContent: "center",
              marginTop: 1,
              textAlign: "center",
              display: showBudget ? "block" : "none"
            }}
          >
            {t("simulator.scenario.budget")}
          </Grid>
          <Grid
            size={{ xs: 7, sm: 7, md: 7 }}
            sx={{
              justifyContent: "center",
              marginTop: 1,
              fontWeight: 600,
              fontSize: 20,
              textAlign: "center",
              display: showBudget ? "block" : "none"
            }}
          >
            {toLocaleString(budget, 0)}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
